exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!@fullcalendar/core/main.css"), "");
exports.i(require("-!../../../../node_modules/css-loader/index.js!@fullcalendar/daygrid/main.css"), "");
exports.i(require("-!../../../../node_modules/css-loader/index.js!@fullcalendar/timegrid/main.css"), "");
exports.i(require("-!../../../../node_modules/css-loader/index.js!@fullcalendar/bootstrap/main.css"), "");

// module
exports.push([module.id, ".fc-event {\n  color: white;\n}", ""]);

// exports
